import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { selectErrorEvent } from 'src/app/store/selectors/app.selectors';
import { IErrorState, IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { MessageBoxCustomButton, MessageDialogComponent } from '../angular-core/components/message-dialog/message-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class StoreErrorService {

  constructor(
    private store: Store<IRemoteXPACPortalState>, public dialog: MatDialog,
    private translate: TranslateService
  ) { }

  public startErrorListener(): void {
    this.store.select(selectErrorEvent)
      .pipe(
        filter<IErrorState>(Boolean),
      )
      .subscribe((data: IErrorState) => {
        function normalizeTranslationKey(key: string): string {
          if (key.startsWith('StoreActionFailed.')) {
            return key;
          }
          return 'StoreActionFailed.' + key;
        }

        let headerText: string = data.translationkey ? this.translate.instant(normalizeTranslationKey(data.translationkey)) : this.translate.instant("General.AnErrorHasOccurred");
        // Use the backend error response, the stack error, or the unknown error message

        function getErrorString(response: HttpErrorResponse): string | undefined {
          if (response.error) {
            const result: string = response.error.toString();
            if (!result.startsWith('[object')) {
              return result;
            }
          }
          return undefined;
        }

        function getMessageString(response: HttpErrorResponse): string | undefined {
          if (response.message) {
            const result: string = response.message.toString();
            if (!result.startsWith('[object')) {
              return result;
            }
          }
          return undefined;
        }

        function getTranslatedError(response: HttpErrorResponse, translate: TranslateService): string | undefined {
          if (data.translationErrorkey !== undefined) {
            const key = normalizeTranslationKey(data.translationErrorkey + "." + response.status);
            const newMessageText: string = translate.instant(key);
            if (newMessageText !== key) {
              return newMessageText;
            }
          }
          return undefined;
        }

        let messageText: string = getTranslatedError(data.error, this.translate) ?? getErrorString(data.error) ?? getMessageString(data.error) ?? this.translate.instant("General.AnUnknownErrorHasOccurred");

        this.dialog.open(MessageDialogComponent, {
          panelClass: 'messagebox-dialog',
          autoFocus: false,
          data: { headerInfo: headerText, message: messageText, buttons: MessageBoxCustomButton.OK }
        });
      });
  }
}
